import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\InvoiceController::index
* @see app/Http/Controllers/InvoiceController.php:18
* @route '/{edition}/invoices'
*/
export const index = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/{edition}/invoices',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\InvoiceController::index
* @see app/Http/Controllers/InvoiceController.php:18
* @route '/{edition}/invoices'
*/
index.url = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { edition: args }
    }

    if (Array.isArray(args)) {
        args = {
            edition: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        edition: args.edition,
    }

    return index.definition.url
            .replace('{edition}', parsedArgs.edition.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\InvoiceController::index
* @see app/Http/Controllers/InvoiceController.php:18
* @route '/{edition}/invoices'
*/
index.get = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\InvoiceController::index
* @see app/Http/Controllers/InvoiceController.php:18
* @route '/{edition}/invoices'
*/
index.head = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\InvoiceController::index
* @see app/Http/Controllers/InvoiceController.php:18
* @route '/{edition}/invoices'
*/
const indexForm = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\InvoiceController::index
* @see app/Http/Controllers/InvoiceController.php:18
* @route '/{edition}/invoices'
*/
indexForm.get = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\InvoiceController::index
* @see app/Http/Controllers/InvoiceController.php:18
* @route '/{edition}/invoices'
*/
indexForm.head = (args: { edition: string | number } | [edition: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\InvoiceController::view
* @see app/Http/Controllers/InvoiceController.php:30
* @route '/{edition}/invoice/{payment}'
*/
export const view = (args: { edition: string | number, payment: string | number } | [edition: string | number, payment: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: view.url(args, options),
    method: 'get',
})

view.definition = {
    methods: ["get","head"],
    url: '/{edition}/invoice/{payment}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\InvoiceController::view
* @see app/Http/Controllers/InvoiceController.php:30
* @route '/{edition}/invoice/{payment}'
*/
view.url = (args: { edition: string | number, payment: string | number } | [edition: string | number, payment: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            edition: args[0],
            payment: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        edition: args.edition,
        payment: args.payment,
    }

    return view.definition.url
            .replace('{edition}', parsedArgs.edition.toString())
            .replace('{payment}', parsedArgs.payment.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\InvoiceController::view
* @see app/Http/Controllers/InvoiceController.php:30
* @route '/{edition}/invoice/{payment}'
*/
view.get = (args: { edition: string | number, payment: string | number } | [edition: string | number, payment: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: view.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\InvoiceController::view
* @see app/Http/Controllers/InvoiceController.php:30
* @route '/{edition}/invoice/{payment}'
*/
view.head = (args: { edition: string | number, payment: string | number } | [edition: string | number, payment: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: view.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\InvoiceController::view
* @see app/Http/Controllers/InvoiceController.php:30
* @route '/{edition}/invoice/{payment}'
*/
const viewForm = (args: { edition: string | number, payment: string | number } | [edition: string | number, payment: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: view.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\InvoiceController::view
* @see app/Http/Controllers/InvoiceController.php:30
* @route '/{edition}/invoice/{payment}'
*/
viewForm.get = (args: { edition: string | number, payment: string | number } | [edition: string | number, payment: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: view.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\InvoiceController::view
* @see app/Http/Controllers/InvoiceController.php:30
* @route '/{edition}/invoice/{payment}'
*/
viewForm.head = (args: { edition: string | number, payment: string | number } | [edition: string | number, payment: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: view.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

view.form = viewForm

const InvoiceController = { index, view }

export default InvoiceController